<template>
    <div style="max-width:480px;">
        <div class="wxOauth-bg">
        </div>
        <div class="wxOauth-loading">
            <div>
                <img src='../../../static/wxOauth/wxOauthLoading.gif' class="wxOauth-img"/>
            </div>
            <div class="wxOauth-span"></div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import api from '../../api'
export default {
  computed: {
    ...mapGetters([
      'g_UserInfo'
    ]),
  },
  data(){
      return {
          isWXBrowser:typeof WeixinJSBridge == "undefined"?false:true,
          redirect:api.getDomainURL()
      }
  },
  activated() {
      this.checkBind();
  },
  methods:{
    checkBind(){
      //获取授权Code
      window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx384b5da598edc120&redirect_uri=http%3a%2f%2fh5.998.com%2fWeChatCard%2fCoupon%2fReviewCheckReturn?response_type=code&scope=snsapi_base&state=activityId%3dAC0042#wechat_redirect";
    }
  }
}
</script>
<style lang="less" scope>
@import "../../assets/theme.less";
   .wxOauth-bg{
       background-color:#000000;
       opacity:0.6;
       position:absolute;top:0;bottom:0;left:0;right:0;
       max-width:480px;
   } 
   .wxOauth-loading{
       position:absolute;
       margin-top:3rem;
       width:70%;
       left:15%;
       background-color:#FFF;
       border-radius:4px;
       z-index:999;
       opacity:1;max-width:336px;
   }
   .wxOauth-img{
       padding-top:20px;
       padding-bottom:20px;
       width:70%;
       margin-left:15%;
   }
   .wxOauth-span{
       text-align:center;
       width:100%;
       padding-bottom:20px;
       color:#333333;
       font-size:0.33rem;
       display:none;
   }
</style>


// WEBPACK FOOTER //
// ReviewCheck.vue?ed4c7a58